<template>
  <div>
    <el-form
      :model="PasswordModel"
      :rules="PasswordModelRules"
      ref="ChangePasswordForm"
      label-width="120px"
    >
      <el-form-item label="新密码：" prop="Password">
        <el-input type="password" v-model="PasswordModel.Password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="ConfirmPassword">
        <el-input type="password" v-model="PasswordModel.ConfirmPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="onChangePassword">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {ChangePassword} from "../../../api/privilege/application_user";
export default {
  name: "ChangePassword",
  data() {
    var validatePasswordEqual = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.PasswordModel.Password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      PasswordModel: {
        Password: "",
        ConfirmPassword: ""
      },
      PasswordModelRules: {
        Password: [
          { required: true, message: "新密码不能为空。", trigger: "change" },
          { min: 6, message: "密码最少6位。", trigger: "change" },
          { max: 20, message: "密码最多20位。", trigger: "change" }
        ],
        ConfirmPassword: [
          { required: true, message: "确认密码不能为空。", trigger: "change" },
          { validator: validatePasswordEqual, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    onChangePassword: function() {
      this.$refs.ChangePasswordForm.validate(valid => {
        if (!valid) {
          return;
        }
        let param=Object.assign({},this.PasswordModel);
        ChangePassword(param).then(result=>{
            if(result.success){
                this.$notify.success('修改密码成功。');
                this.$refs.ChangePasswordForm.resetFields();
                this.$emit('onChangePasswordOk');
            }
        })
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/public/change_password.vue